import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const baseIncluded = ['Sistema 360 Nail artist', '6 tomos estratégicos', 'Acceso inmediato', 'Formato digital PDF'];
const baseExcluded = ['Bono 1: Pack de Scripts WhatsApp', 'Bono 2: Fichero Técnico de Clientas', 'Bono 3: Checklist Operativo Diario', 'Bono 4: Kit de Políticas', 'Bono 5: Planner Semanal', 'Bono 6: Hojas de Costos', 'Acelerador Profesional'];
const completeItems = ['📘 Sistema 360 Nail artist', '📚 6 tomos estratégicos', '⚡ Acceso inmediato', '📄 Formato digital PDF', '💬 Bono 1: Pack de Scripts WhatsApp', '🗂️ Bono 2: Fichero Técnico de Clientas', '✅ Bono 3: Checklist Operativo Diario', '📋 Bono 4: Kit de Políticas', '🗓️ Bono 5: Planner Semanal', '💸 Bono 6: Hojas de Costos', '🚀 Acelerador Profesional'];
export function Offer() {
  return <section id="oferta" className="py-20 bg-white scroll-mt-10" data-id="element-162">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        {/* Urgency & Scarcity Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-164">
          <div className="mb-8" data-id="element-165">
            <p className="text-sm font-bold text-red-600 uppercase tracking-wider mb-4 flex items-center justify-center gap-2" data-id="element-166">
              <span className="relative flex h-3 w-3" data-id="element-167">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-168"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-169"></span>
              </span>
              El precio de lanzamiento termina en:
            </p>
            <CountdownTimer data-id="element-170" />
            <p className="text-gray-500 mt-4 font-medium" data-id="element-171">
              Después sube el precio y no vuelve a bajar.
            </p>
          </div>

          <div className="max-w-md mx-auto bg-gray-50 p-4 rounded-2xl border border-gray-100" data-id="element-172">
            <div className="flex justify-between text-sm font-bold text-red-600 mb-2" data-id="element-173">
              <span data-id="element-174">🔴 Cupos al precio de lanzamiento</span>
              <span data-id="element-175">Quedan pocos</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-176">
              <div className="bg-red-600 h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-177"></div>
            </div>
            <div className="text-right text-xs text-gray-500 font-medium" data-id="element-178">
              68% de los cupos tomados
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto items-stretch" data-id="element-179">
          {/* Option 1: Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-ocean-cream rounded-2xl md:rounded-3xl border border-gray-100 shadow-sm flex flex-col h-full p-6 md:p-8" data-id="element-180">
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center" data-id="element-181">
              Kit Base
            </h3>

            <ul className="space-y-3 mb-8 flex-1 text-sm md:text-base" data-id="element-182">
              {baseIncluded.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-183">
                  <Check className="w-5 h-5 text-ocean-teal shrink-0 mt-0.5" data-id="element-184" />
                  <span className="text-gray-700" data-id="element-185">{item}</span>
                </li>)}
              {baseExcluded.map((item, i) => <li key={i} className="flex items-start gap-3 opacity-40" data-id="element-186">
                  <div className="w-5 h-5 shrink-0" data-id="element-187" />
                  <span className="text-gray-500 line-through" data-id="element-188">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6" data-id="element-189">
              <div className="text-sm text-gray-500 line-through mb-1" data-id="element-190">
                Valor normal: $34.990
              </div>
              <div className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-191">
                $19.990
              </div>
            </div>

            <a href="https://www.tera-ventasonline.shop/cart/45111904567411:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 bg-white border-2 border-ocean-teal text-ocean-teal hover:bg-ocean-teal-light rounded-xl font-bold text-base md:text-lg transition-colors text-center block" data-id="element-192">
              → QUIERO EL KIT BASE
            </a>
          </motion.div>

          {/* Option 2: Complete */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl md:rounded-3xl border-2 border-ocean-teal shadow-soft-lg relative flex flex-col h-full p-6 md:p-8" data-id="element-193">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-ocean-gold text-white px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-194">
              ⭐ Más elegido
            </div>

            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-ocean-teal-dark mt-2" data-id="element-195">
              Kit Completo
            </h3>

            <ul className="space-y-3 mb-8 flex-1 text-sm md:text-base" data-id="element-196">
              {completeItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-197">
                  <Check className="w-5 h-5 text-ocean-gold-dark shrink-0 mt-0.5" data-id="element-198" />
                  <span className="text-gray-900 font-medium" data-id="element-199">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6" data-id="element-200">
              <div className="text-sm text-gray-500 line-through mb-1" data-id="element-201">
                Valor normal: $47.990
              </div>
              <div className="text-4xl md:text-5xl font-bold text-ocean-teal-dark" data-id="element-202">
                $27.990
              </div>
            </div>

            <motion.a href="https://www.tera-ventasonline.shop/cart/45111856431219:1" target="_blank" rel="noopener noreferrer" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            ease: 'easeInOut'
          }} className="w-full py-4 px-6 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-lg md:text-xl transition-colors shadow-lg text-center block" data-id="element-203">
              → QUIERO EL KIT COMPLETO
            </motion.a>
          </motion.div>
        </div>

        {/* Trust strip below pricing */}
        <div className="mt-8 flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-600 font-medium" data-id="element-204">
          <span className="flex items-center gap-1.5" data-id="element-205">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-206">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-207">🛡️ Garantía 7 días</span>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6 max-w-2xl mx-auto" data-id="element-208">
          El cobro se realiza automáticamente en pesos chilenos (CLP). Pagas de
          forma segura a través de Mercado Pago con tarjeta de crédito, débito o
          transferencia.
        </p>
      </div>
    </section>;
}